import * as React from 'react';
import React__default from 'react';

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

var _excluded = ["color", "size", "style"];
var Icon = (function (SvgComponent) {
  return /*#__PURE__*/React__default.forwardRef(function (props, ref) {
    var _props$color = props.color,
        color = _props$color === void 0 ? 'currentColor' : _props$color,
        _props$size = props.size,
        size = _props$size === void 0 ? '1em' : _props$size,
        _props$style = props.style,
        style = _props$style === void 0 ? {} : _props$style,
        otherProps = objectWithoutPropertiesLoose(props, _excluded);

    return /*#__PURE__*/React__default.createElement(SvgComponent, _extends_1({
      ref: ref,
      fill: color,
      width: size,
      height: size,
      style: _extends_1({}, style)
    }, otherProps));
  });
});

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M570.656 277.344H705.28L494.656 487.968a72.64 72.64 0 00-26.688-5.28h-352A73.216 73.216 0 0042.656 556v352A73.344 73.344 0 00116 981.344h352A73.344 73.344 0 00541.344 908V556a72.64 72.64 0 00-5.28-26.688l210.624-210.624v134.624h58.656V218.656H570.688v58.656zm-88 630.656A14.944 14.944 0 01468 922.656H116A14.944 14.944 0 01101.344 908V556A14.944 14.944 0 01116 541.344h352A14.944 14.944 0 01482.656 556v352zm-440-542.656h58.656V424H42.656v-58.656zm0-117.344h58.656v58.656H42.656V248zm880 117.344h58.656V424h-58.656v-58.656zm0-117.344h58.656v58.656h-58.656V248zm0 352h58.656v58.656h-58.656V600zm0 117.344h58.656V776h-58.656v-58.656zm0-234.688h58.656v58.656h-58.656v-58.656zM101.344 101.344h88V42.688H42.688v146.656h58.656v-88zM248 42.656h58.656v58.656H248V42.656zm117.344 0H424v58.656h-58.656V42.656zm117.312 0h58.656v58.656h-58.656V42.656zm117.344 0h58.656v58.656H600V42.656zm117.344 0H776v58.656h-58.656V42.656zM600 922.656h58.656v58.656H600v-58.656zm117.344 0H776v58.656h-58.656v-58.656zm117.312-880v58.656h88v88h58.656V42.656H834.656zm88 880h-88v58.656h146.656V834.656h-58.656v88z"
});

function SvgFullscreen(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "fullscreen_svg__icon",
    width: 200,
    height: 200,
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen);

var ForwardIcon = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(ForwardRef, _extends_1({}, props, {
    ref: ref
  }));
});
var KuFoxIcons = Icon(ForwardIcon);
KuFoxIcons.displayName = 'FullscreenOutlined';

export default KuFoxIcons;
